<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="calls-wrap page-width">
    <div class="title">
      {{ "__CALLS_MY_DEVELOPMENT__" | translate }} {{ !!selectedScenario ? ' / ' +
      selectedScenario.scenarioTitle : '' }}
    </div>
    <app-calls-cards-advanced
      *ngIf="avgStatistics"
      [cards]="cards"
      [statistic]="avgStatistics"
    ></app-calls-cards-advanced>

    <div class="tabs-container">
      <ng-container *ngFor="let tab of tabs">
        <div
          class="tab"
          *ngIf="!tab.requiresScenario || selectedScenario"
          [class.active]="selectedTab === tab.id"
          (click)="selectTab(tab.id)"
        >
          {{ tab.label | translate }}
        </div>
      </ng-container>
    </div>

    <div class="tab-content">
      <ng-container [ngSwitch]="selectedTab">
        <div *ngSwitchCase="'development'">
          <app-calls-table
            *ngIf="learnersStatistic"
            [columns]="tableColumns"
            [rawData]="learnersStatistic"
            (rowClicked)="selectScenario($event)"
          ></app-calls-table> </div>
        <div *ngSwitchCase="'scorecard'">
          <app-calls-scorecard
            *ngIf="sectionStats"
            [scenarios]="aiScenarious"
            [data]="sectionStats"
          ></app-calls-scorecard>
        </div>
        <div *ngSwitchCase="'heatmap'">
          <app-calls-heatmap
            *ngIf="sectionStats"
            [scenarios]="aiScenarious"
            [data]="sectionStats"
          ></app-calls-heatmap>
        </div>
        <div *ngSwitchCase="'mycall'" class="user-overview">
          <app-user-calls-overview
            *ngIf="callsList && !showUserDetails"
            [callList]="callsList"
            (viewRecord)="viewRecord($event)"
          >
          </app-user-calls-overview>

          <app-call-details
            *ngIf="showUserDetails"
            [data]="data"
            (doGoBack)="handleBack()"
          ></app-call-details>
        </div>
        <div *ngSwitchDefault>{{ "__CALLS_NO_CONTENT__" | translate }}</div>
      </ng-container>
    </div>
  </div>
</ion-content>
